import { FC } from 'react';
import { MyOrder, OrderLog } from 'ts/shared/interfaces/MOResponse';
import Table from './Table';
import { moTable } from 'constants/mo';
import { formatMyOrder } from 'utils/shared/my-order';
import withErrorBoundary from '../withErrorBoundary';
import MoOrderTabs2 from './MoOrderTabs2';

interface MoDetailsProps {
  backToOrders: () => void;
  onUpdateMyOrder: (row: MyOrder) => void;
  myOrder: MyOrder;
  onLoadLogs: (logs: OrderLog[]) => void;
}

const MoDetails: FC<MoDetailsProps> = (props) => {
  return (
    <div className="mo-details">
      <Table
        data={[formatMyOrder(props.myOrder)]}
        columns={moTable.filter((t) => t.visible).map((t) => ({ ...t, filter: false }))}
        hideSort={true}
      />
      <MoOrderTabs2
        activeOrder={props.myOrder}
        onUpdateMyOrder={props.onUpdateMyOrder}
        onLoadLogs={props.onLoadLogs}
        showCopyOrderJson
      />
    </div>
  );
};

export default withErrorBoundary(MoDetails, 'MoDetails');
